import React, { FC, useEffect } from 'react';

import { Box, Tooltip as MuiTooltip, useTheme } from '@mui/material';

import { styles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { getIsShowProfileTooltip } from '@bus/profile/selectors';
import { getTooltipId } from '@bus/chat/selectors';
import { chatActions } from '@bus/chat/actions';
import { profileActions } from '@bus/profile/actions';

type TooltipProps = {
  children: React.ReactElement;
  title: React.ReactNode;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
  id: string;
  open?: boolean;
  isBackground?: boolean;
  isOpacityBackground?: boolean;
  arrow?: boolean;
  zIndex?: number;
  mobileCenter?: boolean;
};

export const Tooltip: FC<TooltipProps> = ({
  title,
  children,
  placement,
  id,
  open,
  isBackground = true,
  isOpacityBackground = false,
  arrow = true,
  zIndex = 9997,
  mobileCenter = false,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const tooltipId = useSelector(getTooltipId);
  const isShowProfileTooltip = useSelector(getIsShowProfileTooltip);

  const handleClose = () => {
    isShowProfileTooltip && dispatch(profileActions.closeProfileTooltip());
    dispatch(chatActions.setTooltipStatus(null));
  };

  useEffect(() => {
    if (id.includes('profilePage') && isShowProfileTooltip) {
      dispatch(
        chatActions.setTooltipStatus({ id, isBackground, isOpacityBackground }),
      );

      return;
    }
    if (id.includes('profilePage') && !isShowProfileTooltip) {
      dispatch(chatActions.setTooltipStatus(null));
    }
  }, [isShowProfileTooltip]);

  const handleOpen = () => {
    if (open) {
      dispatch(
        chatActions.setTooltipStatus({ id, isBackground, isOpacityBackground }),
      );
    } else {
      dispatch(chatActions.setTooltipStatus(null));
    }
  };

  return (
    <MuiTooltip
      placement={placement}
      sx={{ height: '100%' }}
      componentsProps={{
        popper: {
          sx: {
            ...styles.tooltip,
            zIndex,
            ...(mobileCenter ? styles.mobileTooltip : {}),
          },
        },
        arrow: {
          sx: {
            color: theme.palette.background.paper,
          },
        },
      }}
      title={title}
      arrow={arrow}
      onClose={handleClose}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      open={tooltipId?.id === id}>
      <Box onClick={handleOpen} display={'flex'} width={'max-content'}>
        {children}
      </Box>
    </MuiTooltip>
  );
};

export default Tooltip;
